import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['htmlContent']

  static values = {
    statusUrl: { type: String, default: "" },
    pollInterval: { type: Number, default: 10000 }
  }

  initialize() {
    setTimeout(() => this.checkStatus(), this.pollIntervalValue)
  }

  checkStatus() {
    fetch(this.statusUrlValue)
      .then(response => response.json())
      .then(data => {
        this.htmlContentTarget.innerHTML = data.html_content

        if (!data.finished) {
          setTimeout(() => this.checkStatus(), this.pollIntervalValue)
        }
      })
  }
}
